import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const ADMITTER = {
  coding: [
    {
      system: 'http://hl7.org/fhir/v3/ParticipationType',
      code: 'ADM',
      display: 'admitter'
    }
  ]
}

const anticipatedDischargeDateEx = {
  url: 'http://narus.com/fhir/anticipated-discharge-date'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Encounter'
  },
  {
    fhir: [ 'type', 0, 'coding', 0 ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'reason', 0, 'text' ],
    form: [ 'reason' ]
  },
  {
    fhir: [ 'participant', 0, 'type', 0 ],
    fhir_const: ADMITTER
  },
  {
    fhir: [ 'participant', 0, 'individual', 'reference' ],
    form: [ 'physician', 'reference' ]
  },
  {
    fhir: [ 'participant', 0, 'individual', 'display' ],
    form: [ 'physician', 'display' ]
  },
  {
    fhir: [ 'serviceProvider', 'display' ],
    form: [ 'facility' ]
  },
  {
    fhir: [ 'status' ],
    form: [ 'status' ],
    to_fhir: () => 'finished',
    to_form: () => false
  },
  {
    fhir: [ 'period', 'start' ],
    form: [ 'admissionDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'period', 'end' ],
    form: [ 'dischargeDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'extension', anticipatedDischargeDateEx, 'valueDate' ],
    form: [ 'anticipatedDischargeDate' ],
    to_fhir: form2fhir
  }
]

export const map = (data, patientId) => {
  const temp = { ...data }
  temp.status = data.status ? data.status : false
  const res = transform(temp, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${patientId}` }
  res.patient = ptRef
  return res
}

export const unmap = data => {
  const form = transform(data, mapping, [ 'fhir', 'form' ])
  return form
}
